import Vue from "vue"
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
Vue.component('date-pick', DatePick)